import { render } from "./ValidatorManagement.vue?vue&type=template&id=b42dbd5a&scoped=true"
import script from "./ValidatorManagement.vue?vue&type=script&lang=js"
export * from "./ValidatorManagement.vue?vue&type=script&lang=js"

import "./ValidatorManagement.vue?vue&type=style&index=0&id=b42dbd5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42dbd5a"]])

export default __exports__